import type { CheckoutConfig, Ecommerce } from '../types/ecommerce.types';

/**
 * Transforms a CheckoutConfig API response to Ecommerce UI model
 */
export const checkoutConfigToEcommerce = (config: CheckoutConfig): Ecommerce => {
  // Determine the type based on configuration
  // This is a basic implementation - adjust based on actual business logic
  const type: Ecommerce['type'] = 'hosted_checkout'; // Default to hosted checkout for now

  // Use the name and description from the API response
  const name = config.name || config.email || `Checkout Config ${config.id}`;
  const description = config.description || `Checkout configuration for ${config.accountId}`;

  return {
    id: config.id,
    name,
    status: config.status,
    type,
    environment: 'production', // You may need to derive this from somewhere
    description,
    // These analytics fields would need to come from a different API endpoint
    // For now, setting default values
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: config.updated,
    created: config.created,
    lastUpdated: config.updated,
    // Pass through additional fields for potential use
    accountId: config.accountId,
    email: config.email,
    primaryColor: config.primaryColor,
    backgroundColor: config.backgroundColor,
    borderStyle: config.borderStyle,
    allowBillingAddress: config.allowBillingAddress,
    allowSaveCard: config.allowSaveCard,
    allowTaxSupport: config.allowTaxSupport,
    taxPercentage: config.taxPercentage,
    allowContactInformation: config.allowContactInformation,
    allowAddressAutocomplete: config.allowAddressAutocomplete,
    allowTermsAccepted: config.allowTermsAccepted,
    allowShippingDetails: config.allowShippingDetails,
    allowQuantityChange: config.allowQuantityChange,
    cartItems: config.cartItems,
    termsUrl: config.termsUrl,
    privacyUrl: config.privacyUrl,
  };
};

/**
 * Transforms multiple CheckoutConfig items to Ecommerce items
 */
export const checkoutConfigsToEcommerce = (configs: CheckoutConfig[]): Ecommerce[] =>
  configs.map(checkoutConfigToEcommerce);
